export interface RawHtmlProps {
  value: string
}

const RawScript = ({ value }: RawHtmlProps) => {
  return <script dangerouslySetInnerHTML={{ __html: value }} />
}

export default RawScript
